import { useCallback, useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { DocxEditor } from "@eigenpal/docx-editor-react";

import { getToken, getLoggedInUserId, getCaseId, getClientId } from "../../Utils/helper";
import "./wordprocessor.css";
import { api_without_cancellation } from "../../api/api";
import { toSentenceCase } from "../DocumentModal/DocumentSideBar/DocumentModalSideBar";
import NewChatIcon from "../../assets/NewChatIcon";
import UploadIcon from "../../../public/bp_assets/img/cloud_icon.svg";
import mixColorWithWhite from "../TreatmentPage/utils/helperFn";
import TFIcon from "../../Components/TreatmentPage/icon/treatment-first-icon-2.png";
import { useChat } from "../AChatWindow/hooks/useChat";
import ChatWindow from "../AChatWindow/components/ChatWindow";
// eslint-disable-next-line import/no-unresolved
import "@eigenpal/docx-editor-react/styles.css";

import ChatDocumentModalWord from "./ChatDocumentModalWord";
import { handleVariableChange2 } from "./helpers";

function WPBase({
  docId,
  updatedDocId,
  dynamicTemplateId,
  setPageId,
  setDropdownId,
  setDocName,
  state,
  dispatch,
  container,
  controls,
  type,
  clientData,
  print,
  download,
  sendEmail,
  deleteDoc,
  draftId,
  setTotalPages,
  setPageNumber,
  height2 = 5,
  saveDocument = () => {},
  closeDocument = () => {},
  downloadDocument = () => {},
  onDLTAutoSave = () => {},
  onDLTContentDirty = () => {},
  onDLTCategoryChange = () => {},
  onDLTInitialCategory = () => {},
  onDLTRename = () => {},
}) {
  const _userId = getLoggedInUserId();
  // const [isPropertyPaneReady, setIsPropertyPaneReady] = useState(false);

  const [dropdownPages, setDropdownPages] = useState([]);
  const [selectedPageOption, setSelectedPageOption] = useState(null);

  const [dropdownVariables, setDropdownVariables] = useState([]);

  const [_footerKey, _setFooterKey] = useState(0);

  const [renameDoc, setRenameDoc] = useState("");

  const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";
  const _token = getToken();

  const saveTimeoutRef = useRef(null);
  const maxSaveTimeoutRef = useRef(null);
  const dltContentGenerationRef = useRef(0);
  const isDocumentReadyRef = useRef(false);
  // const loadFile = useCallback(
  //   async (file) => {
  //     try {
  //       const ajax = new XMLHttpRequest();
  //       ajax.open("POST", container.current?.serviceUrl + "Import", true);
  //       ajax.onreadystatechange = () => {
  //         if (ajax.readyState === 4 && ajax.status === 200) {
  //           container.current?.documentEditor.open(ajax.responseText);
  //           dispatch({ type: "SET_LOADING", payload: false });
  //           // Mark document as ready after it's loaded
  //           setTimeout(() => {
  //             isDocumentReadyRef.current = true;
  //           }, 1000);
  //         } else if (ajax.readyState === 4) {
  //           dispatch({ type: "SET_ERROR", payload: true });
  //         }
  //       };
  //       const formData = new FormData();
  //       formData.append("files", file);
  //       ajax.send(formData);
  //     } catch (error) {
  //       dispatch({ type: "SET_ERROR", payload: true });
  //     }
  //   },
  //   [container, dispatch]
  // );

  // const getDocument = useCallback(async () => {
  //   try {
  //     const response = await api_without_cancellation.get(
  //       `${origin}/api/getDocFile/?doc_id=${updatedDocId ? updatedDocId : docId}`
  //     );
  //     if (response.status === 200) {
  //       const fileResponse = await fetch(response?.data?.upload);
  //       const fileBlob = await fileResponse.blob();
  //       loadFile(fileBlob);
  //     }

  //     // }
  //   } catch (error) {
  //     dispatch({ type: "SET_ERROR", payload: true });
  //   }
  // }, [dispatch, docId, loadFile, origin, updatedDocId]);

  const [buffer, setBuffer] = useState(null);
  const getDocument = useCallback(async () => {
    try {
      const response = await api_without_cancellation.get(
        `/api/getDocFile/?doc_id=${updatedDocId ? updatedDocId : docId}`
      );
      if (response.status === 200) {
        // no-store: S3 objects carry a 24h Cache-Control header; never serve
        // a previously cached (older) copy of the document
        const fileResponse = await fetch(response?.data?.upload, { cache: "no-store" });

        const arrayBuffer = await fileResponse.arrayBuffer();

        setBuffer(arrayBuffer);
        dispatch({ type: "SET_LOADING", payload: false });
        setTimeout(() => {
          isDocumentReadyRef.current = true;
        }, 1000);
      }
    } catch (error) {
      dispatch({ type: "SET_ERROR", payload: true });
    }
  }, [dispatch, docId, updatedDocId]);
  const handlePageChange = (option) => {
    setSelectedPageOption(option);
    documentVariables(option.value);
    if (type === "LetterTemplate") {
      onDLTCategoryChange(option.value === "all" ? null : option.value)?.catch((error) =>
        console.error("Unable to save template category:", error)
      );
    }
    setDropdownOpenManual(false);
  };
  const [contentUpdated, setContentUpdated] = useState(true);

  const performAutoSave = useCallback(async () => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    if (maxSaveTimeoutRef.current) clearTimeout(maxSaveTimeoutRef.current);
    saveTimeoutRef.current = null;
    maxSaveTimeoutRef.current = null;
    if (!container.current) {
      // Editor unmounted; the close path is responsible for the final save
      return;
    }
    if (!isDocumentReadyRef.current) {
      // Preserve the legacy behavior: an early edit waits for the editor
      // rather than being dropped while the document is still loading.
      saveTimeoutRef.current = setTimeout(performAutoSave, 2000);
      return;
    }

    try {
      const contentGeneration = dltContentGenerationRef.current;
      // const documentEditor = container.current.documentEditor;
      // if (!documentEditor || !documentEditor.documentHelper) {
      //   return;
      // }

      // Save as Docx blob with proper error handling
      // const content = await Promise.race([
      //   documentEditor.saveAsBlob("Docx"),
      //   new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
      // ]);

      // Validate content
      // if (!content || content.size === 0) {
      //   return;
      // }
      const content = await Promise.race([
        container.current.save(),
        new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
      ]);
      if (!content || content.byteLength === 0) return;
      const file = new File([content], "autosave.docx", {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      if (type === "LetterTemplate") {
        await onDLTAutoSave(file, contentGeneration);
      } else {
        const formData = new FormData();
        formData.append("doc_id", docId);
        formData.append("file", file);

        // All non-DLT consumers retain the legacy in-place autosave route.
        await api_without_cancellation.post(`${origin}/api/update-edit-doc/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }
    } catch (error) {
      // Silently fail - the error is likely due to incomplete document state
      // This prevents the zip-archive error from showing in console
    }
  }, [container, docId, onDLTAutoSave, origin, type]);

  const autoSaveContent = useCallback(() => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = setTimeout(performAutoSave, 2000);
    // Continuous typing must not postpone the DLT lease update forever.
    if (type === "LetterTemplate" && !maxSaveTimeoutRef.current) {
      maxSaveTimeoutRef.current = setTimeout(performAutoSave, 10000);
    }
  }, [performAutoSave, type]);

  // Cancel any pending debounced save on unmount; it would fire against a
  // nulled editor ref. Callers that close the document flush explicitly.
  useEffect(() => {
    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
      if (maxSaveTimeoutRef.current) {
        clearTimeout(maxSaveTimeoutRef.current);
      }
    };
  }, []);

  const getTemplateData = async (options) => {
    try {
      const response = await api_without_cancellation.get(
        "/api/firmsetting-page/edit-dl-template/",
        {
          params: {
            template_id: dynamicTemplateId,
          },
        }
      );
      if (response.status === 200) {
        const page_id = response.data?.for_page?.id;
        const dropdown_id = response.data?.for_dropdown?.id;
        const temp_name =
          response.data?.for_template?.template_name ??
          response.data?.for_dynamic_letter_template?.for_template?.template_name;
        const doc_name =
          response.data?.for_template?.template?.file_name ??
          response.data?.for_dynamic_letter_template?.for_template?.template?.file_name;

        const copy_temp_name = temp_name + "-copy";

        setPageId(page_id);
        setDropdownId(dropdown_id);

        setDocName(doc_name);
        setRenameDoc(doc_name);

        dispatch({
          type: "SET_TEMP_NAME",
          payload: temp_name,
        });

        dispatch({ type: "SET_FILENAME", payload: copy_temp_name });
        dispatch({ type: "SET_UPDATED_FILENAME", payload: copy_temp_name });

        const lastCategoryId =
          type === "LetterTemplate" ? (response.data?.last_category?.id ?? "all") : page_id;
        const optionSelect = options.find((option) => option.value === lastCategoryId);
        setSelectedPageOption(optionSelect);
        if (type === "LetterTemplate") {
          onDLTInitialCategory(lastCategoryId === "all" ? null : lastCategoryId);
        }
        documentVariables(lastCategoryId);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // Append custom select dropdown to the property tab once it's rendered
    // if (container.current) {
    //   const element = document.querySelector(
    //     ".e-de-ctnr-properties-pane-btn.e-de-pane-disable-clr"
    //   );
    //   if (element) {
    //     element.classList.add("d-none");
    //   }
    //   componentDidMount();
    // }
    // setIsPropertyPaneReady(true); // Property tab is ready for rendering the select component
    documentPages();
  }, []);

  const documentPages = async () => {
    try {
      const response = await api_without_cancellation.get(
        `${origin}/api/firmsetting-page/get-document-variables-pages/`
      );

      if (response.status === 200) {
        const data = response.data;
        const optionPages = [
          {
            value: "all", // or another value of your choice
            label: "All",
          },
          ...data.map((item) => ({
            value: item.id, // map to `value`
            label: (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={item.page_icon}
                  alt="icon"
                  style={{ width: "20px", marginRight: "8px" }}
                />
                {item.name}
              </div>
            ),
          })),
        ];
        setDropdownPages(optionPages);
        getTemplateData(optionPages);
      }
    } catch {
      setDropdownPages([]);
    }
  };

  const documentVariables = async (page_id) => {
    try {
      const response = await api_without_cancellation.get(
        `${origin}/api/firmsetting-page/get-document-variables/?page_id=` + page_id
      );

      if (response.status === 200) {
        const data = response.data;
        const filteredData = data.filter((item) => item.button_name !== null);
        setDropdownVariables(filteredData);
      }
    } catch {
      setDropdownVariables([]);
    }
  };

  const renameDocFileName = async () => {
    try {
      if (type === "LetterTemplate") {
        await onDLTRename(renameDoc);
        return;
      }
      const formData = new FormData();
      formData.append("doc_id", docId);
      formData.append("file_name", renameDoc);

      const response = await api_without_cancellation.post(
        `${origin}/api/rename-doc-wp/`,
        formData
      );
      if (response.status === 200) {
        if (response.data.success) {
          dispatch({
            type: "SHOW_MODAL",
            payload: `${renameDoc} renamed successfully!`,
          });
          setDocName(renameDoc);
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  useEffect(() => {
    // if (container.current) {
    getDocument();
    // }
  }, [getDocument]);

  // const toolbarItems = useMemo(() => {
  //   const baseItems = [
  //     // "New",
  //     // "Open",
  //     "Separator",
  //     "Undo",
  //     "Redo",
  //     "Separator",
  //     "Image",
  //     "Table",
  //     "Hyperlink",
  //     "Bookmark",
  //     "TableOfContents",
  //     "Separator",
  //     "Header",
  //     "Footer",
  //     "PageSetup",
  //     "PageNumber",
  //     "Break",
  //     "InsertFootnote",
  //     "InsertEndnote",
  //     "Separator",
  //     "Find",
  //     "Separator",
  //     "Comments",
  //     "TrackChanges",
  //     "Separator",
  //     "LocalClipboard",
  //     "RestrictEditing",
  //     "Separator",
  //     "FormFields",
  //     "UpdateFields",
  //   ];

  //   return baseItems;
  // }, []);

  // const documenteditor = container?.current?.documentEditor;

  // function componentDidMount() {
  //   if (!documenteditor) {
  //     return;
  //   } else {
  //     documenteditor.selectionChange = () => {
  //       setTimeout(() => {
  //         onSelectionChange();
  //       }, 20);
  //     };
  //   }
  // }

  //To change the font Style of selected content
  // function changeFontFamily(args) {
  //   documenteditor.selection.characterFormat.fontFamily = args.value;
  //   documenteditor.focusIn();
  // }
  // //To Change the font Size of selected content
  // function changeFontSize(args) {
  //   documenteditor.selection.characterFormat.fontSize = args.value;
  //   documenteditor.focusIn();
  // }
  // //To Change the font Color of selected content
  // function changeFontColor(args) {
  //   if (!documenteditor) {
  //     return;
  //   } else {
  //     documenteditor.selection.characterFormat.fontColor = args.currentValue.hex;
  //     documenteditor.focusIn();
  //   }
  // }
  //Selection change to retrieve formatting
  // function onSelectionChange() {
  //   if (documenteditor.selection) {
  //     enableDisableFontOptions();
  //     // #endregion
  //   }
  // }
  // const changeFontFamily = useCallback(
  //   (args) => {
  //     documenteditor.selection.characterFormat.fontFamily = args.value;
  //     documenteditor.focusIn();
  //   },
  //   [documenteditor]
  // );

  // const changeFontSize = useCallback(
  //   (args) => {
  //     documenteditor.selection.characterFormat.fontSize = args.value;
  //     documenteditor.focusIn();
  //   },
  //   [documenteditor]
  // );

  // const changeFontColor = useCallback(
  //   (args) => {
  //     if (!documenteditor) {
  //       return;
  //     } else {
  //       documenteditor.selection.characterFormat.fontColor = args.currentValue.hex;
  //       documenteditor.focusIn();
  //     }
  //   },
  //   [documenteditor]
  // );

  // function enableDisableFontOptions() {
  //   const characterformat = documenteditor.selection.characterFormat;
  //   const properties = [
  //     characterformat.bold,
  //     characterformat.italic,
  //     characterformat.underline,
  //     characterformat.strikethrough,
  //   ];
  //   const toggleBtnId = ["bold", "italic", "underline", "strikethrough"];
  //   for (let i = 0; i < properties.length; i++) {
  //     changeActiveState(properties[i], toggleBtnId[i]);
  //   }
  // }
  // function changeActiveState(property, btnId) {
  //   const toggleBtn = document.getElementById(btnId);
  //   if (
  //     (typeof property === "boolean" && property === true) ||
  //     (typeof property === "string" && property !== "None")
  //   )
  //     toggleBtn.classList.add("e-btn-toggle");
  //   else {
  //     if (toggleBtn.classList.contains("e-btn-toggle")) toggleBtn.classList.remove("e-btn-toggle");
  //   }
  // }

  // function toolbarButtonClick(arg) {
  //   switch (arg.item.id) {
  //     case "AlignLeft":
  //       //Toggle the Left alignment for selected or current paragraph
  //       documenteditor.editor.toggleTextAlignment("Left");
  //       break;
  //     case "AlignRight":
  //       //Toggle the Right alignment for selected or current paragraph
  //       documenteditor.editor.toggleTextAlignment("Right");
  //       break;
  //     case "AlignCenter":
  //       //Toggle the Center alignment for selected or current paragraph
  //       documenteditor.editor.toggleTextAlignment("Center");
  //       break;
  //     case "Justify":
  //       //Toggle the Justify alignment for selected or current paragraph
  //       documenteditor.editor.toggleTextAlignment("Justify");
  //       break;
  //     case "IncreaseIndent":
  //       //Increase the left indent of selected or current paragraph
  //       documenteditor.editor.increaseIndent();
  //       break;
  //     case "DecreaseIndent":
  //       //Decrease the left indent of selected or current paragraph
  //       documenteditor.editor.decreaseIndent();
  //       break;
  //     case "ClearFormat":
  //       documenteditor.editor.clearFormatting();
  //       break;
  //     case "ShowParagraphMark":
  //       //Show or hide the hidden characters like spaces, tab, paragraph marks, and breaks.
  //       documenteditor.documentEditorSettings.showHiddenMarks =
  //         !documenteditor.documentEditorSettings.showHiddenMarks;
  //       break;
  //     case "bold":
  //       //Toggles the bold of selected content
  //       documenteditor.editor.toggleBold();
  //       break;
  //     case "italic":
  //       //Toggles the Italic of selected content
  //       documenteditor.editor.toggleItalic();
  //       break;
  //     case "underline":
  //       //Toggles the underline of selected content
  //       documenteditor.editor.toggleUnderline("Single");
  //       break;
  //     case "strikethrough":
  //       //Toggles the strikethrough of selected content
  //       documenteditor.editor.toggleStrikethrough();
  //       break;
  //     case "subscript":
  //       //Toggles the subscript of selected content
  //       documenteditor.editor.toggleSubscript();
  //       break;
  //     case "superscript":
  //       //Toggles the superscript of selected content
  //       documenteditor.editor.toggleSuperscript();
  //       break;
  //   }
  // }
  //Change the line spacing of selected or current paragraph
  // function lineSpacingAction(args) {
  //   const text = args.item.text;
  //   switch (text) {
  //     case "Single":
  //       documenteditor.selection.paragraphFormat.lineSpacing = 1;
  //       break;
  //     case "1.15":
  //       documenteditor.selection.paragraphFormat.lineSpacing = 1.15;
  //       break;
  //     case "1.5":
  //       documenteditor.selection.paragraphFormat.lineSpacing = 1.5;
  //       break;
  //     case "Double":
  //       documenteditor.selection.paragraphFormat.lineSpacing = 2;
  //       break;
  //   }
  //   setTimeout(() => {
  //     documenteditor.focusIn();
  //   }, 30);
  // }
  // Selection change to retrieve formatting
  // function onSelectionChange() {
  //   if (documenteditor.selection) {
  //     enableDisableFontOptions();
  //     const paragraphFormat = documenteditor.selection.paragraphFormat;
  //     const toggleBtnId = [
  //       "AlignLeft",
  //       "AlignCenter",
  //       "AlignRight",
  //       "Justify",
  //       "ShowParagraphMark",
  //     ];
  //     //Remove toggle state.
  //     for (let i = 0; i < toggleBtnId.length; i++) {
  //       const toggleBtn = document.getElementById(toggleBtnId[i]);
  //       toggleBtn.classList.remove("e-btn-toggle");
  //     }
  //     //Add toggle state based on selection paragraph format.
  //     if (paragraphFormat.textAlignment === "Left") {
  //       document.getElementById("AlignLeft").classList.add("e-btn-toggle");
  //     } else if (paragraphFormat.textAlignment === "Right") {
  //       document.getElementById("AlignRight").classList.add("e-btn-toggle");
  //     } else if (paragraphFormat.textAlignment === "Center") {
  //       document.getElementById("AlignCenter").classList.add("e-btn-toggle");
  //     } else {
  //       document.getElementById("Justify").classList.add("e-btn-toggle");
  //     }
  //     if (documenteditor.documentEditorSettings.showHiddenMarks) {
  //       document.getElementById("ShowParagraphMark").classList.add("e-btn-toggle");
  //     }
  //     // #endregion
  //   }
  // }

  // const toolbarButtonClick = useCallback(
  //   (arg) => {
  //     switch (arg.item.id) {
  //       case "AlignLeft":
  //         //Toggle the Left alignment for selected or current paragraph
  //         documenteditor.editor.toggleTextAlignment("Left");
  //         break;
  //       case "AlignRight":
  //         //Toggle the Right alignment for selected or current paragraph
  //         documenteditor.editor.toggleTextAlignment("Right");
  //         break;
  //       case "AlignCenter":
  //         //Toggle the Center alignment for selected or current paragraph
  //         documenteditor.editor.toggleTextAlignment("Center");
  //         break;
  //       case "Justify":
  //         //Toggle the Justify alignment for selected or current paragraph
  //         documenteditor.editor.toggleTextAlignment("Justify");
  //         break;
  //       case "IncreaseIndent":
  //         //Increase the left indent of selected or current paragraph
  //         documenteditor.editor.increaseIndent();
  //         break;
  //       case "DecreaseIndent":
  //         //Decrease the left indent of selected or current paragraph
  //         documenteditor.editor.decreaseIndent();
  //         break;
  //       case "ClearFormat":
  //         documenteditor.editor.clearFormatting();
  //         break;
  //       case "ShowParagraphMark":
  //         //Show or hide the hidden characters like spaces, tab, paragraph marks, and breaks.
  //         documenteditor.documentEditorSettings.showHiddenMarks =
  //           !documenteditor.documentEditorSettings.showHiddenMarks;
  //         break;
  //       case "bold":
  //         //Toggles the bold of selected content
  //         documenteditor.editor.toggleBold();
  //         break;
  //       case "italic":
  //         //Toggles the Italic of selected content
  //         documenteditor.editor.toggleItalic();
  //         break;
  //       case "underline":
  //         //Toggles the underline of selected content
  //         documenteditor.editor.toggleUnderline("Single");
  //         break;
  //       case "strikethrough":
  //         //Toggles the strikethrough of selected content
  //         documenteditor.editor.toggleStrikethrough();
  //         break;
  //       case "subscript":
  //         //Toggles the subscript of selected content
  //         documenteditor.editor.toggleSubscript();
  //         break;
  //       case "superscript":
  //         //Toggles the superscript of selected content
  //         documenteditor.editor.toggleSuperscript();
  //         break;
  //     }
  //   },
  //   [documenteditor]
  // );

  // const lineSpacingAction = useCallback(
  //   (args) => {
  //     const text = args.item.text;
  //     switch (text) {
  //       case "Single":
  //         documenteditor.selection.paragraphFormat.lineSpacing = 1;
  //         break;
  //       case "1.15":
  //         documenteditor.selection.paragraphFormat.lineSpacing = 1.15;
  //         break;
  //       case "1.5":
  //         documenteditor.selection.paragraphFormat.lineSpacing = 1.5;
  //         break;
  //       case "Double":
  //         documenteditor.selection.paragraphFormat.lineSpacing = 2;
  //         break;
  //     }
  //     setTimeout(() => {
  //       documenteditor.focusIn();
  //     }, 30);
  //   },
  //   [documenteditor]
  // );

  // const onSelectionChange = useCallback(() => {
  //   if (documenteditor.selection) {
  //     enableDisableFontOptions();
  //     const paragraphFormat = documenteditor.selection.paragraphFormat;
  //     const toggleBtnId = [
  //       "AlignLeft",
  //       "AlignCenter",
  //       "AlignRight",
  //       "Justify",
  //       "ShowParagraphMark",
  //     ];
  //     //Remove toggle state.
  //     for (let i = 0; i < toggleBtnId.length; i++) {
  //       const toggleBtn = document.getElementById(toggleBtnId[i]);
  //       toggleBtn.classList.remove("e-btn-toggle");
  //     }
  //     //Add toggle state based on selection paragraph format.
  //     if (paragraphFormat.textAlignment === "Left") {
  //       document.getElementById("AlignLeft").classList.add("e-btn-toggle");
  //     } else if (paragraphFormat.textAlignment === "Right") {
  //       document.getElementById("AlignRight").classList.add("e-btn-toggle");
  //     } else if (paragraphFormat.textAlignment === "Center") {
  //       document.getElementById("AlignCenter").classList.add("e-btn-toggle");
  //     } else {
  //       document.getElementById("Justify").classList.add("e-btn-toggle");
  //     }
  //     if (documenteditor.documentEditorSettings.showHiddenMarks) {
  //       document.getElementById("ShowParagraphMark").classList.add("e-btn-toggle");
  //     }
  //     // #endregion
  //   }
  // }, [documenteditor]);

  // function contentTemplate1() {
  //   return (
  //     <DropDownButtonComponent
  //       items={items}
  //       iconCss="e-de-ctnr-linespacing  e-icons"
  //       select={lineSpacingAction}
  //     />
  //   );
  // }

  // const contentTemplate1 = useCallback(() => {
  //   return (
  //     <DropDownButtonComponent
  //       items={items}
  //       iconCss="e-de-ctnr-linespacing e-icons"
  //       select={lineSpacingAction}
  //     />
  //   );
  // }, [lineSpacingAction]);
  // function contentTemplate2() {
  //   return (
  //     <div>
  //       <ColorPickerComponent showButtons={true} value="#000000" change={changeFontColor} />
  //     </div>
  //   );
  // }
  // const contentTemplate2 = useCallback(() => {
  //   return (
  //     <div>
  //       <ColorPickerComponent showButtons={true} value="#000000" change={changeFontColor} />
  //     </div>
  //   );
  // }, [changeFontColor]);
  // function contentTemplate3() {
  //   return (
  //     <div>
  //       <ComboBoxComponent
  //         dataSource={fontStyle}
  //         select={changeFontFamily}
  //         index={2}
  //         allowCustom={true}
  //         showClearButton={false}
  //       />
  //     </div>
  //   );
  // }
  // function contentTemplate4() {
  //   return (
  //     <div>
  //       <ComboBoxComponent
  //         dataSource={fontSize}
  //         change={changeFontSize}
  //         index={2}
  //         allowCustom={true}
  //         showClearButton={false}
  //       />
  //     </div>
  //   );
  // }
  // const contentTemplate3 = useCallback(() => {
  //   return (
  //     <div>
  //       <ComboBoxComponent
  //         dataSource={fontStyle}
  //         select={changeFontFamily}
  //         index={2}
  //         allowCustom={true}
  //         showClearButton={false}
  //       />
  //     </div>
  //   );
  // }, [changeFontFamily]);

  // const contentTemplate4 = useCallback(() => {
  //   return (
  //     <div>
  //       <ComboBoxComponent
  //         dataSource={fontSize}
  //         change={changeFontSize}
  //         index={2}
  //         allowCustom={true}
  //         showClearButton={false}
  //       />
  //     </div>
  //   );
  // }, [changeFontSize]);

  // Add this near your other refs at the top of WPBase

  const [containerHeight, setContainerHeight] = useState(21);
  const textRef = useRef(null);
  const LINE_HEIGHT = 21;
  const MAX_HEIGHT = 84;

  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current;
      const scrollHeight = element.scrollHeight;
      const numberOfLines = Math.ceil(scrollHeight / LINE_HEIGHT);
      const newHeight = Math.min(numberOfLines * LINE_HEIGHT, MAX_HEIGHT);
      setContainerHeight(newHeight);
    }
  }, [state?.tempName]);

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({
    chatDoc: false,
    taskLink: false,
    docReview: false,
  });
  const dropdownRefs = {
    chatDoc: useRef(null),
    taskLink: useRef(null),
    docReview: useRef(null),
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.entries(dropdownRefs).forEach(([key, ref]) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setDropdownOpen((prev) => ({ ...prev, [key]: false }));
        }
      });
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [pages, setPages] = useState([]);
  const [slotsData, setSlotsData] = useState([]);
  const [showMenuBar, setShowMenuBar] = useState(false);
  const [panelMenuBar, setPanelMenuBar] = useState(false);
  const [documentPanelsData, setDocumentPanelsData] = useState(null);

  const splitItemsIntoCol = (items) => {
    const totalItems = items.length;
    const midPoint = Math.ceil(totalItems / 2);

    return {
      leftCol: items.slice(0, midPoint),
      rightCol: items.slice(midPoint),
    };
  };

  const displayablePages = pages.filter((page) => {
    const slotData = slotsData?.find((slot) => slot?.page?.name === page?.name);
    return page?.is_notes_category && slotData && slotData.page_slots.length > 0;
  });

  const { leftCol, rightCol } = splitItemsIntoCol(displayablePages);

  useEffect(() => {
    const fetchDataFirstTime = async () => {
      try {
        const response = await api_without_cancellation.get(
          "api/doc-page/list-page-doc-optimized/",
          {
            params: {
              page_id: "",
              case_id: clientData ? clientData?.case?.id : getCaseId(),
              all_docs: "True",
              client_id: clientData ? clientData?.client?.id : getClientId(),
            },
          }
        );
        if (response.status === 200) {
          setSlotsData(response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (clientData) {
      fetchDataFirstTime();
    }
  }, [clientData]);

  const refetchDocumentChanges = async () => {
    try {
      const response = await api_without_cancellation.get("api/doc-page/list-page-doc-optimized/", {
        params: {
          page_id: "",
          case_id: clientData ? clientData?.case?.id : getCaseId(),
          all_docs: "True",
          client_id: clientData ? clientData?.client?.id : getClientId(),
        },
      });
      if (response.status === 200) {
        setSlotsData(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const [pdfDocId, setPdfDocId] = useState(null);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const fetchPageDetails = async (caseId) => {
    try {
      const response = await api_without_cancellation.get(`/api/pages/${caseId}/`);

      setPages(response.data);
    } catch (error) {
      console.error("Error occurred while fetching pages", error);
    }
  };

  useEffect(() => {
    setPages([]);
    if (clientData?.case?.id) {
      fetchPageDetails(clientData?.case?.id);
    }
  }, [clientData]);
  const [pendingSlotAction, setPendingSlotAction] = useState(null);
  // shape: { slot, docsInSlot }

  const handleCancel = () => {
    setPendingSlotAction(null);
    setConfirmationModal(false);
  };

  const submitDocument = async ({ slot, page, action, isPanels = false }) => {
    // const documentEditor = container.current.documentEditor;
    // if (!documentEditor || !documentEditor.documentHelper) {
    //   return;
    // }

    // Save as Docx blob with proper error handling
    // const blob = await Promise.race([
    //   documentEditor.saveAsBlob("Docx"),
    //   new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
    // ]);
    const blob = await Promise.race([
      container.current.save(),
      new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
    ]);

    const docxFile = new File([blob], `${state?.tempName || "document"}.docx`, {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    const formData = new FormData();

    formData.append("case_id", getCaseId());
    formData.append("client_id", getClientId());
    formData.append("page_id", page?.id);
    if (pdfDocId && !contentUpdated) {
      // If pdf_doc_id exists, send only the ID
      formData.append("pdf_doc_id", String(pdfDocId));
    } else {
      // Otherwise send the file
      formData.append("file", docxFile);
    }
    formData.append("is_draft_changed", contentUpdated ? true : false);
    formData.append("draft_id", draftId);
    formData.append("slot", slot?.id);
    formData.append("is_panels", isPanels);
    formData.append("move_to_page", action === "move" ? true : false);
    formData.append("delete_and_replace", action === "delete" ? true : false);
    try {
      const res = await api_without_cancellation.post("/api/documents/pdf-to-casefile/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setContentUpdated(false);

      setPdfDocId(res?.data?.doc_id);

      refetchDocumentChanges();
    } catch (error) {
      console.error(error);
      // setSlotsData(previousSlotData);
    }
  };

  const submitDocumentWithPanel = async ({ slot, page, panel, action, isPanels = true }) => {
    // const documentEditor = container.current.documentEditor;
    // if (!documentEditor || !documentEditor.documentHelper) {
    //   return;
    // }

    // Save as Docx blob with proper error handling
    // const blob = await Promise.race([
    //   documentEditor.saveAsBlob("Docx"),
    //   new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
    // ]);
    const blob = await Promise.race([
      container.current.save(),
      new Promise((_, reject) => setTimeout(() => reject(new Error("Save timeout")), 5000)),
    ]);

    const docxFile = new File([blob], `${state?.tempName || "document"}.docx`, {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    const formData = new FormData();

    formData.append("case_id", getCaseId());
    formData.append("client_id", getClientId());
    formData.append("page_id", page?.id);
    if (pdfDocId && !contentUpdated) {
      // If pdf_doc_id exists, send only the ID
      formData.append("pdf_doc_id", String(pdfDocId));
    } else {
      // Otherwise send the file
      formData.append("file", docxFile);
    }
    formData.append("is_draft_changed", contentUpdated ? true : false);
    formData.append("draft_id", draftId);
    formData.append("slot", slot?.id);
    formData.append("panel_id", panel?.id);
    formData.append("is_panels", isPanels);
    formData.append("move_to_page", action === "move" ? true : false);
    formData.append("delete_and_replace", action === "delete" ? true : false);
    try {
      const res = await api_without_cancellation.post("/api/documents/pdf-to-casefile/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setContentUpdated(false);

      setPdfDocId(res?.data?.doc_id);

      refetchDocumentChanges();
    } catch (error) {
      console.error(error);
      // setSlotsData(previousSlotData);
    }
  };

  const {
    users,
    loading: chatLoading,
    error: chatError,
    sendMessage,
    searchUsers,
    messages,
    typingUsers,
    handleTyping,
    markAsRead,
    loadMoreMessages,
    handleSelectUser,
  } = useChat({ skipInitialization: true });
  const [updatedUser, setUpdatedUser] = useState({});
  const [chatDocumentThread, setChatDocumentThread] = useState(false);

  const handleMoveExisting = async () => {
    if (!pendingSlotAction) return;

    const { slot, page, panel } = pendingSlotAction;
    setConfirmationModal(false);
    if (!panel) {
      await submitDocument({
        slot,
        page,
        action: "move",
      });
    } else {
      await submitDocumentWithPanel({
        slot,
        page,
        panel,
        action: "move",
      });
    }

    setPendingSlotAction(null);
  };
  const handleDeleteExisting = async () => {
    if (!pendingSlotAction) return;

    const { slot, page, panel } = pendingSlotAction;

    setConfirmationModal(false);

    if (!panel) {
      await submitDocument({
        slot,
        page,
        action: "delete",
      });
    } else {
      await submitDocumentWithPanel({
        slot,
        page,
        panel,
        action: "delete",
      });
    }

    setPendingSlotAction(null);
  };

  // Letter Temp
  const [dropdownOpenManual, setDropdownOpenManual] = useState(false);
  const pageDropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (pageDropdownRef.current && !pageDropdownRef.current.contains(event.target)) {
        setDropdownOpenManual(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pageDropdownRef]);
  const getPageCount = () => {
    if (!container.current) return 1;

    // Try the direct method first
    const direct = container.current.getTotalPages?.();
    if (direct && direct > 1) return direct;

    // Fall back to layout engine
    const editorRef = container.current.getEditorRef?.();
    const layout = editorRef?.getLayout?.();
    if (layout?.pages?.length) return layout.pages.length;

    return 1;
  };

  if (!docId || state.error) {
    return (
      <div className="doc-error">
        <p>Document not found!</p>
      </div>
    );
  }

  return (
    <>
      <div
        className="d-flex align-items-center m-t-5"
        style={{
          height: `calc(100% - ${height2}px)`,
          width: "100%",
          overflow: "hidden",
        }}
      >
        <div
          // className=" ps-0 pe-0"
          className={`ps-0 pe-0 ${["GenerateDocument", "Draft"].includes(type) ? "" : ""}`}
          style={{
            opacity: state.loading ? 0 : 1,
            pointerEvents: state.loading ? "none" : "auto",
            height: "100%",
            width: chatDocumentThread
              ? "50%"
              : ["GenerateDocument", "Draft"].includes(type)
                ? "80%"
                : "calc(100% - 350px)",
            flexGrow: "1",
            ...(["GenerateDocument", "Draft"].includes(type) &&
              {
                // width: `calc(100% - ${chatDocumentThread ? 680 : 220}px)`,
                // minWidth: `calc(100% - ${chatDocumentThread ? 680 : 220}px)`,
                // flex: 1,
                // maxWidth: "calc(100% - 220px)",
              }),
          }}
        >
          <>
            {/* <ToolbarComponent id="toolbar" clicked={toolbarButtonClick}>
              <ItemsDirective>
                <ItemDirective
                  id="AlignLeft"
                  key="AlignLeft"
                  prefixIcon="e-de-ctnr-alignleft e-icons"
                  tooltipText="Align Left"
                  cssClass="toolbar-group-alignment"
                />
                <ItemDirective
                  id="AlignCenter"
                  key="AlignCenter"
                  prefixIcon="e-de-ctnr-aligncenter e-icons"
                  tooltipText="Align Center"
                  cssClass="toolbar-group-alignment"
                />
                <ItemDirective
                  id="AlignRight"
                  key="AlignRight"
                  prefixIcon="e-de-ctnr-alignright e-icons"
                  tooltipText="Align Right"
                  cssClass="toolbar-group-alignment"
                />
                <ItemDirective
                  id="Justify"
                  key="Justify"
                  prefixIcon="e-de-ctnr-justify e-icons"
                  tooltipText="Justify"
                  cssClass="toolbar-group-alignment"
                />
                <ItemDirective />
                <ItemDirective
                  id="IncreaseIndent"
                  key="IncreaseIndent"
                  prefixIcon="e-de-ctnr-increaseindent e-icons"
                  tooltipText="Increase Indent"
                  cssClass="toolbar-group-indent"
                />
                <ItemDirective
                  id="DecreaseIndent"
                  key="DecreaseIndent"
                  prefixIcon="e-de-ctnr-decreaseindent e-icons"
                  tooltipText="Decrease Indent"
                  cssClass="toolbar-group-indent"
                />
                <ItemDirective />
                <ItemDirective
                  id="LineSpacing"
                  key="LineSpacing"
                  cssClass="toolbar-group-formatting"
                  template={contentTemplate1}
                />
                <ItemDirective
                  id="ClearFormat"
                  key="ClearFormat"
                  prefixIcon="e-de-ctnr-clearall e-icons"
                  tooltipText="Clear Formatting"
                  cssClass="toolbar-group-formatting"
                />
                <ItemDirective />
                <ItemDirective
                  id="ShowParagraphMark"
                  key="ShowParagraphMark"
                  prefixIcon="e-de-e-paragraph-mark e-icons"
                  tooltipText="Show the hidden characters like spaces, tab, paragraph marks, and breaks.(Ctrl + *)"
                  cssClass="toolbar-group-paragraph"
                />

                <ItemDirective
                  id="bold"
                  key="bold"
                  prefixIcon="e-de-ctnr-bold"
                  tooltipText="Bold"
                  cssClass="toolbar-group-textstyle"
                />
                <ItemDirective
                  id="italic"
                  key="italic"
                  prefixIcon="e-de-ctnr-italic"
                  tooltipText="Italic"
                  cssClass="toolbar-group-textstyle"
                />
                <ItemDirective
                  id="underline"
                  key="underline"
                  prefixIcon="e-de-ctnr-underline"
                  tooltipText="Underline"
                  cssClass="toolbar-group-textstyle"
                />
                <ItemDirective
                  id="strikethrough"
                  key="strikethrough"
                  prefixIcon="e-de-ctnr-strikethrough"
                  tooltipText="Strikethrough"
                  cssClass="toolbar-group-textstyle"
                />
                <ItemDirective
                  id="subscript"
                  key="subscript"
                  prefixIcon="e-de-ctnr-subscript"
                  tooltipText="Subscript"
                  cssClass="toolbar-group-textstyle"
                />
                <ItemDirective
                  id="superscript"
                  key="superscript"
                  prefixIcon="e-de-ctnr-superscript"
                  tooltipText="Superscript"
                  cssClass="toolbar-group-textstyle"
                />
                <ItemDirective />
                <ItemDirective
                  id="FontColor"
                  key="FontColor"
                  cssClass="toolbar-group-color"
                  template={contentTemplate2}
                />
                <ItemDirective />
                <ItemDirective
                  id="FontFamily"
                  key="FontFamily"
                  cssClass="toolbar-group-font"
                  template={contentTemplate3}
                />
                <ItemDirective />
                <ItemDirective
                  id="FontSize"
                  key="FontSize"
                  cssClass="toolbar-group-font"
                  template={contentTemplate4}
                />
              </ItemsDirective>
            </ToolbarComponent> */}

            {/* <DocumentEditorContainerComponent
              id="container"
              height=""
              ref={container}
              serviceUrl="https://document.syncfusion.com/web-services/docx-editor/api/documenteditor/"
              toolbarItems={toolbarItems}
              enableToolbar={true}
              enablePropertiesPane={true}
              style={{
                // minWidth: "1200px",
                height: "calc(100% - 5px)",
              }}
              showPropertiesPane={false}
              onContentChange={() => {
                autoSaveContent();
                setContentUpdated(true);

                const pages = container.current?.documentEditor?.pageCount;
                if (pages) setTotalPages(pages);
              }}
              selectionChange={() => {
                // Update current page on selection change
                const currentPage = container.current?.documentEditor?.selection?.startPage;
                if (currentPage) setPageNumber(currentPage);
              }}
            /> */}

            {buffer && (
              <DocxEditor
                ref={container}
                documentBuffer={buffer}
                mode="editing"
                documentName={state?.tempName}
                showToolbar
                showRuler={false}
                showZoomControl={false}
                onChange={() => {
                  if (type === "LetterTemplate") {
                    dltContentGenerationRef.current += 1;
                    onDLTContentDirty(dltContentGenerationRef.current);
                  }
                  autoSaveContent();
                  setContentUpdated(true);
                  const total = getPageCount();
                  if (total) setTotalPages(total);
                  // const current = container.current?.getCurrentPage?.();
                  // if (current) setPageNumber(current);
                }}
                onSelectionChange={() => {
                  const current = container.current?.getCurrentPage?.();

                  if (current) setPageNumber(current);
                }}
                onFontsLoaded={() => {
                  isDocumentReadyRef.current = true;
                  setTimeout(() => {
                    const total = getPageCount();
                    if (total) setTotalPages(total);
                  }, 500);
                }}
                // onError={(err) => {
                //   console.error("DocxEditor error:", err);
                //   dispatch({ type: "SET_ERROR", payload: true });
                // }}
                style={{ height: "calc(100% - 5px)" }}
              />
            )}
          </>
        </div>

        <div
          className={`ps-0 p-r-5 ${["GenerateDocument", "Draft"].includes(type) ? "" : ""}`}
          style={
            ["GenerateDocument", "Draft"].includes(type)
              ? { minWidth: "220px", maxWidth: "220px", height: "100%" }
              : ["LetterTemplate"].includes(type)
                ? { minWidth: "275px", maxWidth: "275px", height: "100%" }
                : { minWidth: "350px", maxWidth: "350px", height: "100%" }
          }
        >
          {!["GenerateDocument", "Draft"].includes(type) && (
            <div className="d-flex mx-auto">
              <div className="col-sm-12 ps-0 pe-0">{controls ? controls : controls}</div>
            </div>
          )}
          {["GenerateDocument", "Draft"].includes(type) && (
            <>
              <div
                className="right-sidebar d-flex flex-column"
                style={{ width: "220px", zIndex: "1", minWidth: "220px", height: "100%" }}
              >
                <div
                  className="d-flex flex-column justify-content-between h-100"
                  style={{
                    backgroundColor: "#f2f5f7",
                  }}
                >
                  {/* Case Block */}
                  {/* <div>
                    <span
                      className="color-main text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
                      style={{
                        fontSize: "14px",
                        height: "25px",
                        borderRadius: "0px",
                      }}
                    >
                      CASE
                    </span>
                    <div
                      className="client-name d-flex align-items-center side-bar-padding"
                      style={{ height: "25px", background: "var(--primary-2)" }}
                    >
                      <UserProfile clientInfo={clientData?.client} />
                    </div>
                    <div
                      className="tile-row w-100 p-l-5 p-r-5 d-flex flex-column align-items-start"
                      style={{ height: "42px", background: "var(--primary-4)" }}
                    >
                      <div className="d-flex align-items-center" style={{ height: "21px" }}>
                        {clientData?.case?.case_type?.icon && (
                          <span
                            className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                            style={{ marginRight: "5px" }}
                          >
                            <img
                              style={{
                                width: "15px",
                                height: "15px",
                              }}
                              src={clientData?.case?.case_type?.icon}
                              alt="icon"
                            />
                          </span>
                        )}

                        <p className="text-black font-weight-semibold d-block">
                          {clientData?.case?.case_type?.name || "N/A"}
                        </p>
                      </div>
                      <div className="d-flex align-items-center" style={{ height: "21px" }}>
                        <span
                          className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                          style={{ marginRight: "5px" }}
                        >
                          <img
                            src={incidentIcon}
                            className=""
                            style={{
                              width: "15px",
                              height: "15px",
                            }}
                          />
                        </span>

                        <p className="font-weight-semibold">
                          {formatCalendarDate(clientData?.case?.incident_date) || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div> */}

                  {/* Draft Name */}
                  <div>
                    <span
                      className="color-main m-t-0 text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
                      style={{
                        fontSize: "14px",
                        height: "25px",
                        borderRadius: "0px",
                      }}
                    >
                      DRAFT NAME
                    </span>

                    <div
                      className="tile-row mw-100 flex-wrap d-flex align-items-center p-l-5 p-r-5"
                      style={{
                        height: `${containerHeight}px`,
                        minHeight: "21px",
                        maxHeight: `${MAX_HEIGHT}px`,
                        transition: "height 0.1s ease",
                        overflow: "hidden",
                        background: "var(--primary-2)",
                      }}
                    >
                      <span
                        ref={textRef}
                        className="text-black text-start text-break font-weight-semibold d-block"
                      >
                        {state?.tempName}
                      </span>
                    </div>
                  </div>

                  {/* Create Document */}
                  <div className="">
                    <span
                      className="color-main text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
                      style={{
                        fontSize: "14px",
                        height: "25px",
                        borderRadius: "0px",
                      }}
                    >
                      Save PDF Copy To
                    </span>

                    <ul
                      className="d-flex document-pop-up-menu-sidebar"
                      style={{ paddingLeft: "0px", flexDirection: "row" }}
                    >
                      <div
                        style={{
                          flex: "1",
                        }}
                      >
                        {leftCol &&
                          leftCol.map((page, _index) => {
                            // Find the corresponding slot data for the current page
                            const slotData = slotsData.find((slot) => slot.page.name === page.name);

                            if (
                              page.is_notes_category &&
                              slotData &&
                              slotData.page_slots.length > 0
                            ) {
                              const { panels, page_slots } = slotData;

                              // If panels exist, show panels first

                              if (
                                page_slots.length > 0 &&
                                page.name === "Treatment" &&
                                page.panels
                              ) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "35px",
                                            // padding: "0 10px",
                                            paddingTop: "0px",
                                            paddingLeft: "25px",
                                            paddingRight: "10px",
                                            paddingBottom: "0px",
                                            // background: "white",
                                            cursor: "pointer",
                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }

                                            // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "capitalize",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center color-grey-2"
                                            style={{ gap: "0px", width: "100%" }}
                                          >
                                            {/* <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      ></span> */}
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {panelIndex + 1}
                                            </span>
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              <img
                                                src={TFIcon}
                                                alt="tf-icon"
                                                style={{
                                                  height: "25px",
                                                  width: "25px",
                                                  position: "relative",
                                                  right: "0px",
                                                  bottom: "0px",
                                                }}
                                              />
                                            </span>

                                            <span
                                              className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "black",
                                                width: "calc(100% - 25px)",
                                                background: mixColorWithWhite(
                                                  panel?.specialty?.color,
                                                  10
                                                ),
                                              }}
                                            >
                                              <span
                                                style={{
                                                  background: panel?.specialty?.color,

                                                  fontSize: "16px",
                                                  fontWeight: "700",
                                                  height: "25px",
                                                  width: "25px",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  color: "white",
                                                  marginRight: "5px",
                                                }}
                                              >
                                                {panel?.specialty?.name[0] ?? ""}
                                              </span>
                                              {panel?.panel_name ? panel.panel_name : ""}
                                            </span>
                                          </a>
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "250px",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right: "91%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                  // background: documentData
                                                  //   ? mixColorWithWhite(
                                                  //       documentPanelsData?.specialty?.color,
                                                  //       10
                                                  //     )
                                                  //   : "",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    background:
                                                      documentPanelsData?.specialty?.color,
                                                    fontSize: "16px",
                                                    fontWeight: "700",
                                                    height: "25px",
                                                    width: "25px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    color: "white",
                                                    marginRight: "5px",
                                                  }}
                                                >
                                                  {documentPanelsData?.specialty?.name[0] ?? ""}
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };
                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      background:
                                                        slotIndex % 2 === 0
                                                          ? mixColorWithWhite(
                                                              panel?.specialty?.color,
                                                              2
                                                            )
                                                          : mixColorWithWhite(
                                                              panel?.specialty?.color,
                                                              4
                                                            ),
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-15 ic-file-colored cursor-pointer "
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center whitespace-nowrap  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",

                                                          // height: "25px",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              if (page_slots.length > 0 && page.panels && page.name === "Loans") {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: width > 1400 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);

                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center color-grey-2"
                                            style={{ gap: "0px", width: "100%" }}
                                          >
                                            {/* <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      ></span> */}
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {panelIndex + 1}
                                            </span>
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {/* <img
                                                          src={TFIcon}
                                                          alt="tf-icon"
                                                          style={{
                                                            height: "25px",
                                                            width: "25px",
                                                            position: "relative",
                                                            right: "0px",
                                                            bottom: "0px",
                                                          }}
                                                        /> */}
                                            </span>

                                            <span
                                              className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "black",
                                                width: "calc(100% - 25px)",
                                                background: mixColorWithWhite(
                                                  panel?.specialty?.color,
                                                  10
                                                ),
                                              }}
                                            >
                                              {page?.name === "Offer" ? panel?.panel_name : ""}
                                              {page?.name !== "Offer"
                                                ? panel?.specialty
                                                  ? panel?.specialty.name
                                                  : panel?.panel_name
                                                    ? panel?.panel_name
                                                    : ""
                                                : ""}
                                            </span>
                                          </a>
                                          {/* <a
                                                      className="cursor-pointer d-flex align-items-center"
                                                      // style={{ gap: "5px" }}
                                                      style={{
                                                        color: "var(--primary-25)",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      />
                                                      <span className="ms-2" style={{ fontWeight: "bold" }}>
                                                        {panelIndex + 1}.
                                                      </span>
                                                      <span
                                                        className="ms-2 whitespace-nowrap"
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "var(--primary)",
                                                        }}
                                                      >
                                                        {page?.name === "Offer" ? panel?.panel_name : ""}
                                                        {page?.name !== "Offer"
                                                          ? panel?.specialty
                                                            ? panel?.specialty.name
                                                            : panel?.panel_name
                                                              ? panel?.panel_name
                                                              : ""
                                                          : ""}
                                                      </span>
                                                    </a> */}
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "auto",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right: "88%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  className="p-l-5 d-flex align-items-center"
                                                  style={{
                                                    width: "25px",
                                                    height: "25px",
                                                  }}
                                                >
                                                  <img
                                                    src={page.page_icon ?? ""}
                                                    className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                    // className="document-icons-width"
                                                    alt=""
                                                    style={{
                                                      width: "15px",
                                                      height: "15px",
                                                    }}
                                                  />
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };
                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-15 ic-file-colored cursor-pointer "
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          // height: "25px",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text whitespace-nowrap">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              if (page_slots.length > 0 && page.panels) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      {/* <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "17px",
                                                    height: "17px",
                                                    color: "#19395F",
                                                    transform: "rotate(180deg)",
                                                    backgroundImage:
                                                      showMenuBar === index
                                                        ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                        : "",
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundSize: "contain",
                                                  }}
                                                ></span> */}
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: width > 1400 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center"
                                            // style={{ gap: "5px" }}
                                            style={{
                                              color: "var(--primary-25)",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  panelMenuBar === panelIndex
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                              }}
                                            />
                                            <span className="ms-2" style={{ fontWeight: "bold" }}>
                                              {panelIndex + 1}.
                                            </span>
                                            <span
                                              className="ms-2 whitespace-nowrap"
                                              style={{
                                                fontWeight: "bold",
                                                color: "var(--primary)",
                                              }}
                                            >
                                              {page?.name === "Offer" ? panel?.panel_name : ""}
                                              {page?.name !== "Offer"
                                                ? panel?.specialty
                                                  ? panel?.specialty.name
                                                  : panel?.panel_name
                                                    ? panel?.panel_name
                                                    : ""
                                                : ""}
                                            </span>
                                          </a>
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "auto",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right:
                                                page?.name === "Employment"
                                                  ? "89%"
                                                  : page?.name === "Reports"
                                                    ? "88%"
                                                    : page?.name === "Defendants"
                                                      ? "89%"
                                                      : page?.name === "Insurance"
                                                        ? "93%"
                                                        : page?.name === "Experts"
                                                          ? "88%"
                                                          : "90%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  className="p-l-5 d-flex align-items-center"
                                                  style={{
                                                    width: "25px",
                                                    height: "25px",
                                                  }}
                                                >
                                                  <img
                                                    src={page.page_icon ?? ""}
                                                    className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                    // className="document-icons-width"
                                                    alt=""
                                                    style={{
                                                      width: "15px",
                                                      height: "15px",
                                                    }}
                                                  />
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };

                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-file-colored ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          // height: "25px",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text whitespace-nowrap">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              // If no panels, show page slots directly
                              if (page_slots.length > 0 && !page.panels) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        // top:
                                        //   width < 1920
                                        //     ? `${index * 2 + 30}%`
                                        //     : `${10 + index * 1.5}%`,
                                        left: "auto",
                                        top: "auto",
                                        minWidth: "auto",
                                        transform:
                                          width > 1920
                                            ? "translate(10px, -20px)"
                                            : "translate(10px, -20px)",
                                        right: width > 1920 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", "false");
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}

                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          paddingLeft: "55px",
                                          height: "25px",
                                          paddingRight: "10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center whitespace-nowrap p-r-5"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          Document Row Buttons
                                        </span>
                                      </div>

                                      {page_slots
                                        .filter((slot) => slot.slot_number !== 0)
                                        .map((slot, slotIndex) => {
                                          const docsInSlot = slotData.page_docs?.filter(
                                            (doc) =>
                                              doc.document_slot?.slot_number === slot?.slot_number
                                          );

                                          const handleClick = async () => {
                                            if (docsInSlot.length > 0) {
                                              setPendingSlotAction({ slot, docsInSlot, page });
                                              setConfirmationModal(true);
                                              return;
                                            }

                                            await submitDocument({ slot, page });
                                          };

                                          return (
                                            <li
                                              key={slotIndex}
                                              className="d-flex align-items-center"
                                              style={{
                                                height: "25px",
                                                cursor:
                                                  docsInSlot.length > 0 ? "default" : "pointer",
                                                padding: "0px 10px",
                                              }}
                                              onClick={handleClick}
                                            >
                                              {slot.slot_number !== 0 && (
                                                <span className="d-flex align-items-center justify-content-center">
                                                  {docsInSlot.length > 0 ? (
                                                    <i
                                                      className="ic ic-15 ic-file-colored cursor-pointer "
                                                      style={{
                                                        backgroundRepeat: "no-repeat",
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src={UploadIcon}
                                                      className=" ic-15 cursor-pointer"
                                                      style={{
                                                        backgroundRepeat: "no-repeat",
                                                      }}
                                                    />
                                                  )}
                                                </span>
                                              )}

                                              {/* {slot.slot_number === 0 && (
                                                        <div
                                                          className="d-flex align-items-center justify-content-center"
                                                          style={{
                                                            width: "100%",
                                                          }}
                                                        >
                                                          <span
                                                            className="d-flex align-items-center whitespace-nowrap "
                                                            style={{ fontWeight: "bold" }}
                                                          >
                                                          
                                                            Attach to {page.name} Page
                                                          </span>
                                                        </div>
                                                      )} */}

                                              {slot.slot_number !== 0 && (
                                                <div
                                                  className={`d-flex align-items-center  ${
                                                    docsInSlot.length === 0 ? "hoverable-text" : ""
                                                  }`}
                                                  style={{
                                                    width: "calc(100% - 25px)",
                                                    fontWeight: "bold",
                                                    color:
                                                      docsInSlot.length === 0
                                                        ? "var(--primary-25)"
                                                        : "inherit",
                                                  }}
                                                >
                                                  <>
                                                    <span className="ms-2 hoverable-text">
                                                      {slot.slot_number}.
                                                    </span>
                                                    <span className="ms-2 hoverable-text whitespace-nowrap">
                                                      {docsInSlot.length > 0
                                                        ? docsInSlot[0].file_name
                                                        : slot.slot_name
                                                          ? slot.slot_name
                                                          : "Available"}
                                                    </span>
                                                  </>
                                                </div>
                                              )}
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </li>
                                );
                              }
                            }

                            return null;
                          })}
                      </div>
                      <div
                        style={{
                          flex: "1",
                        }}
                      >
                        {rightCol &&
                          rightCol.map((page, _index) => {
                            // Find the corresponding slot data for the current page
                            const slotData = slotsData.find((slot) => slot.page.name === page.name);

                            if (
                              page.is_notes_category &&
                              slotData &&
                              slotData.page_slots.length > 0
                            ) {
                              const { panels, page_slots } = slotData;

                              // If panels exist, show panels first

                              if (
                                page_slots.length > 0 &&
                                page.name === "Treatment" &&
                                page.panels
                              ) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "35px",
                                            // padding: "0 10px",
                                            paddingTop: "0px",
                                            paddingLeft: "25px",
                                            paddingRight: "10px",
                                            paddingBottom: "0px",
                                            // background: "white",
                                            cursor: "pointer",
                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "capitalize",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center color-grey-2"
                                            style={{ gap: "0px", width: "100%" }}
                                          >
                                            {/* <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      ></span> */}
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {panelIndex + 1}
                                            </span>
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              <img
                                                src={TFIcon}
                                                alt="tf-icon"
                                                style={{
                                                  height: "25px",
                                                  width: "25px",
                                                  position: "relative",
                                                  right: "0px",
                                                  bottom: "0px",
                                                }}
                                              />
                                            </span>

                                            <span
                                              className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "black",
                                                width: "calc(100% - 25px)",
                                                background: mixColorWithWhite(
                                                  panel?.specialty?.color,
                                                  10
                                                ),
                                              }}
                                            >
                                              <span
                                                style={{
                                                  background: panel?.specialty?.color,

                                                  fontSize: "16px",
                                                  fontWeight: "700",
                                                  height: "25px",
                                                  width: "25px",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  color: "white",
                                                  marginRight: "5px",
                                                }}
                                              >
                                                {panel?.specialty?.name[0] ?? ""}
                                              </span>
                                              {panel?.panel_name ? panel.panel_name : ""}
                                            </span>
                                          </a>
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "250px",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right: "91%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                  // background: documentData
                                                  //   ? mixColorWithWhite(
                                                  //       documentPanelsData?.specialty?.color,
                                                  //       10
                                                  //     )
                                                  //   : "",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    background:
                                                      documentPanelsData?.specialty?.color,
                                                    fontSize: "16px",
                                                    fontWeight: "700",
                                                    height: "25px",
                                                    width: "25px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    color: "white",
                                                    marginRight: "5px",
                                                  }}
                                                >
                                                  {documentPanelsData?.specialty?.name[0] ?? ""}
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };
                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      background:
                                                        slotIndex % 2 === 0
                                                          ? mixColorWithWhite(
                                                              panel?.specialty?.color,
                                                              2
                                                            )
                                                          : mixColorWithWhite(
                                                              panel?.specialty?.color,
                                                              4
                                                            ),
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-15 ic-file-colored cursor-pointer "
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center whitespace-nowrap  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",

                                                          // height: "25px",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              if (page_slots.length > 0 && page.panels && page.name === "Loans") {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: width > 1400 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center color-grey-2"
                                            style={{ gap: "0px", width: "100%" }}
                                          >
                                            {/* <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      ></span> */}
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {panelIndex + 1}
                                            </span>
                                            <span
                                              className=" d-flex align-items-center justify-content-center"
                                              style={{
                                                fontWeight: "bold",
                                                width: "25px",
                                                height: "25px",
                                                color: "var(--primary-25)",
                                              }}
                                            >
                                              {/* <img
                                                          src={TFIcon}
                                                          alt="tf-icon"
                                                          style={{
                                                            height: "25px",
                                                            width: "25px",
                                                            position: "relative",
                                                            right: "0px",
                                                            bottom: "0px",
                                                          }}
                                                        /> */}
                                            </span>

                                            <span
                                              className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                                color: "black",
                                                width: "calc(100% - 25px)",
                                                background: mixColorWithWhite(
                                                  panel?.specialty?.color,
                                                  10
                                                ),
                                              }}
                                            >
                                              {page?.name === "Offer" ? panel?.panel_name : ""}
                                              {page?.name !== "Offer"
                                                ? panel?.specialty
                                                  ? panel?.specialty.name
                                                  : panel?.panel_name
                                                    ? panel?.panel_name
                                                    : ""
                                                : ""}
                                            </span>
                                          </a>
                                          {/* <a
                                                      className="cursor-pointer d-flex align-items-center"
                                                      // style={{ gap: "5px" }}
                                                      style={{
                                                        color: "var(--primary-25)",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display: "inline-block",
                                                          width: "17px",
                                                          height: "17px",
                                                          color: "#19395F",
                                                          transform: "rotate(180deg)",
                                                          backgroundImage:
                                                            panelMenuBar === panelIndex
                                                              ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                              : "",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundSize: "contain",
                                                        }}
                                                      />
                                                      <span className="ms-2" style={{ fontWeight: "bold" }}>
                                                        {panelIndex + 1}.
                                                      </span>
                                                      <span
                                                        className="ms-2 whitespace-nowrap"
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "var(--primary)",
                                                        }}
                                                      >
                                                        {page?.name === "Offer" ? panel?.panel_name : ""}
                                                        {page?.name !== "Offer"
                                                          ? panel?.specialty
                                                            ? panel?.specialty.name
                                                            : panel?.panel_name
                                                              ? panel?.panel_name
                                                              : ""
                                                          : ""}
                                                      </span>
                                                    </a> */}
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "auto",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right: "88%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  className="p-l-5 d-flex align-items-center"
                                                  style={{
                                                    width: "25px",
                                                    height: "25px",
                                                  }}
                                                >
                                                  <img
                                                    src={page.page_icon ?? ""}
                                                    className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                    // className="document-icons-width"
                                                    alt=""
                                                    style={{
                                                      width: "15px",
                                                      height: "15px",
                                                    }}
                                                  />
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };
                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-15 ic-file-colored cursor-pointer "
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          // height: "25px",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text whitespace-nowrap">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              if (page_slots.length > 0 && page.panels) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      {/* <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "17px",
                                                    height: "17px",
                                                    color: "#19395F",
                                                    transform: "rotate(180deg)",
                                                    backgroundImage:
                                                      showMenuBar === index
                                                        ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                                        : "",
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundSize: "contain",
                                                  }}
                                                ></span> */}
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        top: "auto",
                                        // page.name === "Witnesses"
                                        //   ? `${index * 2 + 3}%`
                                        //   : "auto",
                                        left: "auto",
                                        minWidth: "auto",
                                        transform: "translate(10px, -20px)",
                                        right: width > 1400 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", true);
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-between"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}
                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          // paddingLeft: "55px",
                                          height: "25px",
                                          padding: "0 10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          {page?.panel_name}
                                        </span>
                                      </div>
                                      {panels?.length === 0 && (
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            // paddingLeft: "55px",
                                            height: "50px",
                                            padding: "0 10px",
                                            background: "var(--primary-2)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "14px",
                                              color: "var(--primary-25)",
                                              width: "100%",
                                              // textTransform: "",
                                            }}
                                          >
                                            {toSentenceCase(`No ${page?.panel_name}`)}
                                          </span>
                                        </li>
                                      )}
                                      {panels.map((panel, panelIndex) => (
                                        <li
                                          key={panelIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            // padding: "0px 10px",
                                            height: "25px",
                                          }}
                                          onMouseEnter={() => {
                                            setDocumentPanelsData(panel);
                                            setPanelMenuBar(panelIndex);
                                          }}
                                          onMouseLeave={() => {
                                            setDocumentPanelsData([]);
                                            setPanelMenuBar(null);
                                          }}
                                        >
                                          <a
                                            className="cursor-pointer d-flex align-items-center"
                                            // style={{ gap: "5px" }}
                                            style={{
                                              color: "var(--primary-25)",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  panelMenuBar === panelIndex
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                              }}
                                            />
                                            <span className="ms-2" style={{ fontWeight: "bold" }}>
                                              {panelIndex + 1}.
                                            </span>
                                            <span
                                              className="ms-2 whitespace-nowrap"
                                              style={{
                                                fontWeight: "bold",
                                                color: "var(--primary)",
                                              }}
                                            >
                                              {page?.name === "Offer" ? panel?.panel_name : ""}
                                              {page?.name !== "Offer"
                                                ? panel?.specialty
                                                  ? panel?.specialty.name
                                                  : panel?.panel_name
                                                    ? panel?.panel_name
                                                    : ""
                                                : ""}
                                            </span>
                                          </a>
                                          <ul
                                            className="document-pop-up-sidebar-menubar"
                                            style={{
                                              position: "absolute",
                                              // left: "auto",
                                              top:
                                                width < 1400
                                                  ? `${panelIndex * 2 + 18}%`
                                                  : `${10 + panelIndex * 2}%`,
                                              left: "auto",
                                              // top: "auto",
                                              minWidth: "auto",
                                              transform:
                                                width > 1400
                                                  ? `translate(0px, -${panelIndex + 15}%)`
                                                  : `translate(0px, -${panelIndex + 30}%)`,
                                              // right: "17.2%",
                                              right:
                                                page?.name === "Employment"
                                                  ? "89%"
                                                  : page?.name === "Reports"
                                                    ? "88%"
                                                    : page?.name === "Defendants"
                                                      ? "89%"
                                                      : page?.name === "Insurance"
                                                        ? "93%"
                                                        : page?.name === "Experts"
                                                          ? "88%"
                                                          : "90%",
                                              display: panelMenuBar === panelIndex ? "block" : "",
                                              width: "max-content",
                                            }}
                                          >
                                            <li
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "0px",
                                                height: "25px",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "black",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  className="p-l-5 d-flex align-items-center"
                                                  style={{
                                                    width: "25px",
                                                    height: "25px",
                                                  }}
                                                >
                                                  <img
                                                    src={page.page_icon ?? ""}
                                                    className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                    // className="document-icons-width"
                                                    alt=""
                                                    style={{
                                                      width: "15px",
                                                      height: "15px",
                                                    }}
                                                  />
                                                </span>
                                                {documentPanelsData?.panel_name
                                                  ? documentPanelsData.panel_name
                                                  : ""}
                                              </span>
                                            </li>
                                            <li
                                              className="bg-primary-5 d-flex align-items-center"
                                              style={{
                                                paddingLeft: "55px",
                                                height: "25px",
                                                paddingRight: "10px",
                                                // background: "var(--primary-15)",
                                              }}
                                            >
                                              <span
                                                className="d-flex align-items-center whitespace-nowrap p-r-5"
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "var(--primary)",
                                                  width: "100%",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                Document Row Buttons
                                              </span>
                                            </li>
                                            {page_slots.map((slot, slotIndex) => {
                                              const docsInSlot = panel.documents?.filter(
                                                (doc) =>
                                                  doc.document_slot?.slot_number ===
                                                  slot?.slot_number
                                              );
                                              const handleClick = async () => {
                                                if (docsInSlot.length > 0) {
                                                  setPendingSlotAction({
                                                    slot,
                                                    docsInSlot,
                                                    page,
                                                    panel,
                                                  });
                                                  setConfirmationModal(true);
                                                  return;
                                                }

                                                await submitDocumentWithPanel({
                                                  slot,
                                                  page,
                                                  panel,
                                                });
                                              };

                                              return (
                                                slot.slot_number !== 0 && (
                                                  <li
                                                    key={slotIndex}
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      padding: "0px 10px",
                                                      height: "25px",
                                                      cursor:
                                                        docsInSlot.length > 0
                                                          ? "default"
                                                          : "pointer",
                                                    }}
                                                    onClick={handleClick}
                                                  >
                                                    {slot.slot_number !== 0 && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        {docsInSlot.length > 0 ? (
                                                          <i
                                                            className="ic ic-file-colored ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        ) : (
                                                          <img
                                                            src={UploadIcon}
                                                            className=" ic-15 cursor-pointer"
                                                            style={{
                                                              backgroundRepeat: "no-repeat",
                                                            }}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {/* 
                                                          {slot.slot_number === 0 && (
                                                            <span className="d-flex align-items-center ms-2">
                                                              <img
                                                                src={page.page_icon ?? ""}
                                                                className="document-icons-width  cursor-pointer m-r-5"
                                                                alt=""
                                                              />
                                                              Attach to {page.name} Page
                                                            </span>
                                                          )} */}

                                                    {slot.slot_number !== 0 && (
                                                      <div
                                                        className={`d-flex align-items-center  ${
                                                          docsInSlot.length === 0
                                                            ? "hoverable-text"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          width: "calc(100% - 25px)",
                                                          fontWeight: "bold",
                                                          // height: "25px",
                                                          color:
                                                            docsInSlot.length === 0
                                                              ? "var(--primary-25)"
                                                              : "inherit",
                                                        }}
                                                      >
                                                        <>
                                                          <span className="ms-2 hoverable-text">
                                                            {slot.slot_number}.
                                                          </span>
                                                          <span className="ms-2 hoverable-text whitespace-nowrap">
                                                            {docsInSlot.length > 0
                                                              ? docsInSlot[0].file_name
                                                              : slot.slot_name
                                                                ? slot.slot_name
                                                                : "Available"}
                                                          </span>
                                                        </>
                                                      </div>
                                                    )}
                                                  </li>
                                                )
                                              );
                                            })}
                                          </ul>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              }

                              // If no panels, show page slots directly
                              if (page_slots.length > 0 && !page.panels) {
                                return (
                                  <li
                                    key={page?.id}
                                    className=""
                                    onMouseEnter={() => setShowMenuBar(page?.id)}
                                    onMouseLeave={() => setShowMenuBar(null)}
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <a
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        height: "21px",
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px-2"
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                        }}
                                        alt=""
                                      />
                                      {page.name}
                                      <span className="caret" />
                                    </a>
                                    <ul
                                      className="document-pop-up-sidebar-menubar"
                                      style={{
                                        position: "absolute",
                                        // left: "auto",
                                        // top:
                                        //   width < 1920
                                        //     ? `${index * 2 + 30}%`
                                        //     : `${10 + index * 1.5}%`,
                                        left: "auto",
                                        top: "auto",
                                        minWidth: "auto",
                                        transform:
                                          width > 1920
                                            ? "translate(10px, -20px)"
                                            : "translate(10px, -20px)",
                                        right: width > 1920 ? "120px" : "120px",
                                        display: showMenuBar === page?.id ? "block" : "",
                                        width: "max-content",
                                        zIndex: 2,
                                      }}
                                    >
                                      {page_slots.find((slot) => slot.slot_number === 0) && (
                                        <li
                                          className="d-flex align-items-center background-white-hover-primary-four"
                                          style={{
                                            padding: "0px 10px 0px 25px",
                                            height: "35px",
                                            cursor: "pointer",
                                            // background: "white",

                                            color: "var(--primary)",

                                            fontWeight: "600",
                                            fontSize: "14px",
                                            textTransform: "capitalize",
                                          }}
                                          onClick={async () => {
                                            const slot = page_slots.find(
                                              (slot) => slot?.slot_number === 0
                                            );
                                            // const documentEditor = container.current.documentEditor;
                                            // if (!documentEditor || !documentEditor.documentHelper) {
                                            //   return;
                                            // }
                                            const blob = await Promise.race([
                                              container.current.save(),
                                              new Promise((_, reject) =>
                                                setTimeout(
                                                  () => reject(new Error("Save timeout")),
                                                  5000
                                                )
                                              ),
                                            ]);
                                            // // Save as Docx blob with proper error handling
                                            // const blob = await Promise.race([
                                            //   documentEditor.saveAsBlob("Docx"),
                                            //   new Promise((_, reject) =>
                                            //     setTimeout(
                                            //       () => reject(new Error("Save timeout")),
                                            //       5000
                                            //     )
                                            //   ),
                                            // ]);

                                            const docxFile = new File(
                                              [blob],
                                              `${state?.tempName || "document"}.docx`,
                                              {
                                                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                              }
                                            );
                                            const formData = new FormData();

                                            formData.append("case_id", getCaseId());
                                            formData.append("client_id", getClientId());
                                            formData.append("page_id", page?.id);
                                            if (pdfDocId && !contentUpdated) {
                                              // If pdf_doc_id exists, send only the ID
                                              formData.append("pdf_doc_id", String(pdfDocId));
                                            } else {
                                              // Otherwise send the file
                                              formData.append("file", docxFile);
                                            }
                                            formData.append(
                                              "is_draft_changed",
                                              contentUpdated ? true : false
                                            );
                                            formData.append("draft_id", draftId);
                                            formData.append("slot", slot?.id);
                                            formData.append("is_panels", "false");
                                            formData.append("move_to_page", "false");
                                            formData.append("delete_and_replace", "false");

                                            try {
                                              const res = await api_without_cancellation.post(
                                                "/api/documents/pdf-to-casefile/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );
                                              setContentUpdated(false);

                                              setPdfDocId(res?.data?.doc_id);

                                              refetchDocumentChanges();
                                            } catch (error) {
                                              console.error(error);
                                              // setSlotsData(previousSlotData);
                                            }
                                          }}
                                        >
                                          <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{ width: "100%" }}
                                          >
                                            <span
                                              className="d-flex align-items-center whitespace-nowrap "
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <span
                                                className="m-r-5 d-flex align-items-center"
                                                style={{
                                                  width: "29px",
                                                  height: "29px",
                                                }}
                                              >
                                                <img
                                                  src={page.page_icon ?? ""}
                                                  className=" d-flex align-items-center justify-content-center cursor-pointer"
                                                  // className="document-icons-width"
                                                  alt=""
                                                  style={{
                                                    width: "29px",
                                                    height: "29px",
                                                  }}
                                                />
                                              </span>
                                              Attach to {page.name} Page
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "17px",
                                                height: "17px",
                                                color: "#19395F",
                                                transform: "rotate(180deg)",
                                                backgroundImage:
                                                  showMenuBar === page?.id
                                                    ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                    : "",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                marginRight: "-10px",
                                              }}
                                            />
                                          </div>
                                        </li>
                                      )}

                                      <div
                                        className="bg-primary-5 d-flex align-items-center"
                                        style={{
                                          paddingLeft: "55px",
                                          height: "25px",
                                          paddingRight: "10px",
                                          // background: "var(--primary-15)",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center whitespace-nowrap p-r-5"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "var(--primary)",
                                            width: "100%",
                                            textTransform: "uppercase",
                                          }}
                                        >
                                          Document Row Buttons
                                        </span>
                                      </div>

                                      {page_slots
                                        .filter((slot) => slot.slot_number !== 0)
                                        .map((slot, slotIndex) => {
                                          const docsInSlot = slotData.page_docs?.filter(
                                            (doc) =>
                                              doc.document_slot?.slot_number === slot?.slot_number
                                          );

                                          const handleClick = async () => {
                                            if (docsInSlot.length > 0) {
                                              setPendingSlotAction({ slot, docsInSlot, page });
                                              setConfirmationModal(true);
                                              return;
                                            }

                                            await submitDocument({ slot, page });
                                          };

                                          return (
                                            <li
                                              key={slotIndex}
                                              className="d-flex align-items-center"
                                              style={{
                                                height: "25px",
                                                cursor:
                                                  docsInSlot.length > 0 ? "default" : "pointer",
                                                padding: "0px 10px",
                                              }}
                                              onClick={handleClick}
                                            >
                                              {slot.slot_number !== 0 && (
                                                <span className="d-flex align-items-center justify-content-center">
                                                  {docsInSlot.length > 0 ? (
                                                    <i
                                                      className="ic ic-15 ic-file-colored cursor-pointer "
                                                      style={{
                                                        backgroundRepeat: "no-repeat",
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src={UploadIcon}
                                                      className=" ic-15 cursor-pointer"
                                                      style={{
                                                        backgroundRepeat: "no-repeat",
                                                      }}
                                                    />
                                                  )}
                                                </span>
                                              )}

                                              {/* {slot.slot_number === 0 && (
                                                        <div
                                                          className="d-flex align-items-center justify-content-center"
                                                          style={{
                                                            width: "100%",
                                                          }}
                                                        >
                                                          <span
                                                            className="d-flex align-items-center whitespace-nowrap "
                                                            style={{ fontWeight: "bold" }}
                                                          >
                                                          
                                                            Attach to {page.name} Page
                                                          </span>
                                                        </div>
                                                      )} */}

                                              {slot.slot_number !== 0 && (
                                                <div
                                                  className={`d-flex align-items-center  ${
                                                    docsInSlot.length === 0 ? "hoverable-text" : ""
                                                  }`}
                                                  style={{
                                                    width: "calc(100% - 25px)",
                                                    fontWeight: "bold",
                                                    color:
                                                      docsInSlot.length === 0
                                                        ? "var(--primary-25)"
                                                        : "inherit",
                                                  }}
                                                >
                                                  <>
                                                    <span className="ms-2 hoverable-text">
                                                      {slot.slot_number}.
                                                    </span>
                                                    <span className="ms-2 hoverable-text whitespace-nowrap">
                                                      {docsInSlot.length > 0
                                                        ? docsInSlot[0].file_name
                                                        : slot.slot_name
                                                          ? slot.slot_name
                                                          : "Available"}
                                                    </span>
                                                  </>
                                                </div>
                                              )}
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </li>
                                );
                              }
                            }

                            return null;
                          })}
                      </div>

                      {pages?.length === 0 &&
                        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((index) => (
                          <li key={index} className="">
                            <a
                              className="cursor-pointer d-flex align-items-center justify-content-center shimmer-effect relative overflow-hidden"
                              style={{
                                height: width > 2120 ? "25px" : "25px",
                                backgroundColor:
                                  index % 2 === 0 ? "var(--primary-2)" : "var(--primary-4)",
                              }}
                            >
                              <div
                                className="absolute inset-0"
                                style={{
                                  animation: "shimmer 2s infinite linear",
                                  background:
                                    "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%)",
                                  backgroundSize: "1000px 100%",
                                }}
                              >
                                {index === 7 && (
                                  <span
                                    style={{
                                      color: "var(--primary-50)",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    Attach Document To Case First
                                  </span>
                                )}
                              </div>
                            </a>
                          </li>
                        ))}
                    </ul>
                  </div>

                  <div
                    className=""
                    style={{
                      display: height <= 1024 ? "flex" : "flex",
                      justifyContent: height <= 1024 ? "space-between" : "initial",
                      background: "white",
                      padding: "5px",
                      gap: "5px",
                      flexDirection: height <= 1024 ? "row" : "column",
                    }}
                  >
                    {/* Chat Document Link Dropdown */}

                    <div className="tile-row w-100  center-content my-auto">
                      <div className="dropdown  d-flex" ref={dropdownRefs.chatDoc}>
                        <button
                          className={`btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn ${dropdownOpen.chatDoc ? "show" : ""}`}
                          type="button"
                          // onClick={() => toggleDropdown("chatDoc")}
                          onClick={handleShow}
                          aria-haspopup="true"
                          aria-expanded={dropdownOpen.chatDoc}
                        >
                          <span className="ic-15 d-flex align-items-center justify-content-center">
                            {/* <i className="ic ic-19 ic-chat-3d d-flex align-items-cente justify-content-center" /> */}
                            <NewChatIcon />
                          </span>
                          {height <= 1024 ? "Chat Draft" : "Chat About Draft"}
                        </button>
                        {dropdownOpen.chatDoc && (
                          <div className="dropdown-menu show">{/* Add dropdown items here */}</div>
                        )}
                      </div>
                    </div>

                    {/* Request Document Review Button */}

                    <div className="tile-row w-100 center-content my-auto">
                      <div className="dropdown d-flex" ref={dropdownRefs.docReview}>
                        <button
                          className={`btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn ${dropdownOpen.docReview ? "show" : ""}`}
                          type="button"
                          onClick={toggleModal}
                          aria-haspopup="true"
                          aria-expanded={dropdownOpen.docReview}
                        >
                          <span className="ic-15 d-flex align-items-center justify-content-center">
                            <img
                              src="https://simplefirm-bucket.s3.amazonaws.com/static/images/Tasks_page_icon_color.svg"
                              className="ic ic-15 cursor-pointer d-flex align-items-center justify-content-center"
                            />
                          </span>

                          {height <= 1024 ? "Review" : "Request Draft Review"}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Bottom Buttons */}
                  <div
                    className="d-flex flex-column"
                    style={{ gap: height <= 1024 ? "8px" : "40px" }}
                  >
                    <div className="bottom-content side-bar-padding">
                      <div className="m-b-5 six-buttons m-l-0 m-r-0">
                        <button
                          className="btn btn-primary col height-25 d-flex align-items-center justify-content-center"
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                          onClick={print}
                        >
                          Print
                        </button>
                        <button
                          className="btn btn-primary download-btn col height-25 d-flex align-items-center justify-content-center"
                          onClick={download}
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Download
                        </button>
                        <button
                          className="btn btn-primary col height-25 d-flex align-items-center justify-content-center"
                          onClick={sendEmail}
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Email
                        </button>

                        <button
                          type="button"
                          onClick={deleteDoc}
                          className="btn btn-secondary height-25 d-flex align-items-center justify-content-center flex-g"
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {type === "LetterTemplate" ? (
            <>
              <div className="d-flex mx-auto">
                <div className="col-sm-12 p-l-5 pe-0">
                  <div>
                    <input
                      type="text"
                      className="form-control col height-25 p-l-5 p-0 d-flex align-items-center"
                      value={renameDoc}
                      onChange={(e) => setRenameDoc(e.target.value)}
                    />
                  </div>
                  <div className="d-flex justify-content-end m-t-5 m-b-5">
                    <button
                      type="button"
                      className="btn btn-primary fw-bold  height-25 d-flex align-items-center justify-content-center"
                      onClick={renameDocFileName}
                    >
                      Rename This Template
                    </button>
                  </div>
                </div>
              </div>

              <div className="bg-primary-5 text-primary w-100 fw-bold height-25 d-flex align-items-center justify-content-center m-b-5">
                Document Variables
              </div>
              <div className="row mx-auto">
                <div
                  className="col-sm-12 p-l-5 pe-0 custom-select-new-provider"
                  ref={pageDropdownRef}
                >
                  {/* {true && ( */}

                  <>
                    <div
                      className="dropdown-button form-control pt-0 pb-0  pe-0 rounded-0 height-25 d-flex align-items-center"
                      onClick={() => setDropdownOpenManual((prev) => !prev)}
                      style={{
                        paddingLeft: selectedPageOption ? "0px" : "5px",
                      }}
                    >
                      <span id="selectedOption">
                        {selectedPageOption ? (
                          <div
                            className="d-flex p-l-5 align-items-center justify-content-start "
                            style={{
                              height: "25px",
                              fontSize: "16px",
                              color: "black",
                              fontWeight: "700",
                              gap: "5px",
                            }}
                          >
                            {selectedPageOption?.label}
                          </div>
                        ) : (
                          "Select a Page"
                        )}
                      </span>
                    </div>

                    {/* Dropdown menu */}
                    {dropdownOpenManual && (
                      <div
                        className="dropdown-menu p-0 mt-0"
                        style={{
                          width: "100%",
                          border: "1px solid #ced4da",
                          // borderRadius: "2px",
                          scrollbarWidth: "none",
                          maxHeight: "328px",
                          fontSize: "16px",
                          overflowY: "auto",
                          maxWidth: "210px",
                          left: "5px",
                        }}
                      >
                        {dropdownPages?.map((special) => (
                          <div className={`has-speciality-color-${special?.value}`}>
                            <div
                              key={special.value}
                              className="dropdown-option bg-speciality d-flex align-items-center height-25"
                              style={{
                                color: "black",
                                fontWeight: "700",
                                fontSize: "16px",
                                cursor: "pointer",
                                paddingLeft: "5px",
                              }}
                              onClick={() => handlePageChange(special)}
                            >
                              {special.label}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                  {/* )} */}
                </div>
              </div>
              <div
                className="d-flex mx-auto "
                style={{
                  height: "calc(100% - 205px)",
                }}
              >
                {/* Column 1 (Odd-indexed items) */}
                <div className="col-sm-12 p-l-5 pe-0 text-center">
                  <div className="icon-text-boxes">
                    {dropdownVariables
                      ?.filter((_, index) => index % 2 === 0)
                      .map((variable, index) => (
                        <div
                          key={index}
                          className="text-center height-25 btn-primary-lighter-2 d-flex align-items-center justify-content-center font-weight-semibold cursor-pointer m-t-5"
                          id="no-vertical-border"
                          onClick={() => handleVariableChange2(`{{${variable.name}}}`, container)}
                        >
                          <p className="" style={{ textOverflow: "ellipsis" }}>
                            {variable.button_name || variable?.name}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>

                {/* Column 2 (Even-indexed items) */}
                <div className="col-sm-12 p-l-5 pe-0 text-center">
                  <div className="icon-text-boxes">
                    {dropdownVariables
                      ?.filter((_, index) => index % 2 !== 0)
                      .map((variable, index) => (
                        <div
                          key={index} // Unique key for second column
                          className="text-center height-25 btn-primary-lighter-2 d-flex align-items-center justify-content-center font-weight-semibold  cursor-pointer m-t-5"
                          id="no-vertical-border"
                          onClick={() => handleVariableChange2(`{{${variable.name}}}`, container)}
                        >
                          <p className="" style={{ textOverflow: "ellipsis" }}>
                            {variable.button_name || variable?.name}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div
                className="p-l-5 d-flex align-items-center w-100"
                style={{
                  gap: "5px",
                }}
              >
                <div className="w-100">
                  <button
                    type="button"
                    className="btn btn-primary height-25 d-flex align-items-center justify-content-center fw-bold w-100"
                    onClick={saveDocument}
                  >
                    Save
                  </button>
                </div>

                <div className="w-100">
                  <button
                    type="button"
                    className="btn btn-primary fw-bold height-25 d-flex align-items-center justify-content-center w-100"
                    onClick={downloadDocument}
                  >
                    Download
                  </button>
                </div>
                <div className="w-100">
                  <button
                    type="button"
                    className="btn btn-secondary fw-bold height-25 d-flex align-items-center justify-content-center w-100"
                    onClick={closeDocument}
                  >
                    Close
                  </button>
                </div>
              </div>
            </>
          ) : null}
        </div>

        {chatDocumentThread && updatedUser && (
          <div
            style={{
              minWidth: "200px",
              flex: "0 0 30%",
              // maxWidth: "460px",
              height: "100%",
            }}
          >
            <ChatWindow
              user={updatedUser}
              messages={messages}
              typingUsers={typingUsers}
              sendMessage={sendMessage}
              handleTyping={handleTyping}
              markAsRead={markAsRead}
              loadMoreMessages={loadMoreMessages}
              source={"chat"}
            />
          </div>
        )}
      </div>

      {confirmationModal && (
        <Modal
          show={confirmationModal}
          // onBackdropClick={handleCancel}
          onHide={handleCancel}
          // backdrop="static"
          centered
        >
          <Modal.Header
            style={{
              borderBottom: "0px",
            }}
            className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
          >
            <Modal.Title
              className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
              id="modal_title"
              style={{ fontSize: "14px", fontWeight: "600" }}
            >
              Document Already Exists
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-3">
            <p className="m-b-5">A document already exists in this page slot.</p>
            <p className="text-muted small">
              Choose what you would like to do with the existing document.
            </p>
          </Modal.Body>

          <Modal.Footer
            className=" p-0 mt-0 padding-outside-btn-new-provider"
            style={{ borderTop: "none" }}
          >
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
              variant="secondary"
              onClick={handleCancel}
            >
              Cancel
            </Button>

            <div
              className="d-flex align-items-center"
              style={{
                gap: "5px",
              }}
            >
              <Button
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
                variant="success"
                onClick={handleMoveExisting}
              >
                Move existing document
              </Button>

              <Button
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
                variant="danger"
                onClick={handleDeleteExisting}
              >
                Delete existing document
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {showModal && (
        <ChatDocumentModalWord
          showModal={showModal}
          handleClose={handleClose}
          users={users}
          loading={chatLoading}
          error={chatError}
          sendMessage={sendMessage}
          searchUsers={searchUsers}
          setChatDocumentThread={setChatDocumentThread}
          setUpdatedUser={setUpdatedUser}
          handleSelectUser={handleSelectUser}
          pageName={"wordprocessor"}
          setPdfDocId={setPdfDocId}
          contentUpdated={contentUpdated}
          pdfDocId={pdfDocId}
          draftId={draftId}
          container={container}
          docName={state.tempName}
        />
      )}
    </>
  );
}

export default WPBase;
